import React from "react";
import { useNavigate } from "react-router-dom";

const PageUnderDevelopment: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        {/* Construction Icon */}
        <div className="mb-8 flex justify-center">
          <div className="relative">
            <div className="text-6xl">🚧</div>
            <div className="absolute -bottom-2 -right-2 text-4xl animate-pulse">⚙️</div>
          </div>
        </div>
        {/* Heading */}
        <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
          Page Under Development
        </h1>

        {/* Description */}
        <p className="text-lg text-slate-600 mb-2">
          We're working hard to bring this feature to you!
        </p>
        <p className="text-sm text-slate-500 mb-8">
          This page is currently being built. Please check back soon or navigate to another section.
        </p>

        {/* Status Box */}
        <div className="bg-white rounded-lg border-2 border-slate-200 p-6 mb-8">
          <div className="flex items-center justify-center gap-3 mb-3">
            <div className="w-3 h-3 bg-yellow-500 rounded-full animate-pulse"></div>
            <span className="text-slate-700 font-semibold">Status: In Progress</span>
          </div>
          <p className="text-xs text-slate-500">
            Expected completion coming soon
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={() => navigate(-1)}
            className="px-6 py-2.5 bg-slate-200 hover:bg-slate-300 text-slate-800 font-medium rounded-lg transition-colors duration-200"
          >
            Go Back
          </button>
         
        </div>

        
      </div>
    </div>
  );
};

export default PageUnderDevelopment;